import { useTranslation } from '@crehana/i18n';

import { HOMEPAGE_PAGE_KEY } from '../constants';
import { TKeys } from '../i18n';

export const useHomeTranslation = () =>
  useTranslation<TKeys>(HOMEPAGE_PAGE_KEY);
